import { Formik, Form, Field } from 'formik'
import { useState } from 'react'
import Column from '@components/column'
import Row from '@components/row'
import FieldOverview from '@commons/cards/fieldOverview'
import { useSelector } from 'react-redux'
import Typography from '@components/typography'
import Modal from '@components/modal'
import Fields from '@components/fields'
import Button from '@components/button'
import Circle from '@components/circle'
import { format } from 'date-fns'
import Svg from '@components/svg'
import { Experience } from '@apis'
import { ExperienceSchema } from '@validations'
import { store, Actions } from '@store'
const initial = {
  name: '',
  role: '',
  startDate: '',
  endDate: '',
  isCurrent: false,
  id: null,
}
const Experiences = () => {
  const { data: user } = useSelector((state: any) => state.user)
  const [visible, setVisible] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [initialValues, setInitialValues] = useState(initial)
  const submitHandler = async (values) => {
    setLoading(true)
    const payload = {
      name: values?.name,
      role: values?.role,
      startDate: values?.startDate,
      endDate: values?.endDate || null,
      isCurrent: values?.isCurrent,
    }
    if (values?.id) {
      await Experience.update({
        id: values?.id,
        data: payload,
      })
        .then((resp) => {
          setVisible(false)

          const findIndex = user?.experiences?.findIndex(
            (experience: any) => experience?.id == resp?.id,
          )
          if (findIndex !== -1 && findIndex !== undefined) {
            const updatedExperiences = [...(user?.experiences || [])]
            updatedExperiences[findIndex] = resp
            store.dispatch(
              Actions.update('user', {
                ...user,
                experiences: updatedExperiences,
              }),
            )
          }
          setInitialValues(initial)
        })
        .catch(() => {})
    } else {
      await Experience.create({
        data: payload,
      })
        .then((resp) => {
          setVisible(false)
          store.dispatch(
            Actions.update('user', {
              ...user,
              experiences: [resp, ...user?.experiences],
            }),
          )
          setInitialValues(initial)
        })
        .catch(() => {})
    }
    setLoading(false)
  }
  return (
    <Column>
      <FieldOverview
        title="Experiences"
        icon="circlePlus"
        onClick={() => {
          setVisible(true)
        }}
      >
        {!!user?.experiences?.length ? (
          <Row colGap={15}>
            {user?.experiences?.map((experience: any) => {
              return (
                <Row alignItems="center" colGap={5}>
                  <Circle size={10} bg={'inputBorder'} />
                  <Typography
                    content={`${format(experience?.startDate, 'yyyy')}-${format(experience?.endDate, 'yyyy')}-${experience?.role},${experience?.name}`}
                    size={12}
                  />
                  <Column
                    onClick={() => {
                      setInitialValues({
                        id: experience?.id,
                        name: experience?.name,
                        role: experience?.role,
                        startDate: format(experience?.startDate, 'yyyy-MM-dd'),
                        endDate: format(experience?.endDate, 'yyyy-MM-dd'),
                        isCurrent: experience?.isCurrent,
                      })
                      setVisible(true)
                    }}
                  >
                    <Svg svg="edit" color={'secondary'} size={12} />
                  </Column>
                </Row>
              )
            })}
          </Row>
        ) : (
          <Typography
            content="Add your Experience details..."
            size={12}
            tc="text"
          />
        )}
      </FieldOverview>
      <Modal
        visible={visible}
        title={initialValues?.id ? 'Update Experience' : 'Add Experience'}
        onClose={() => {
          setVisible(false)
          setInitialValues(initial)
        }}
      >
        <Formik
          initialValues={initialValues}
          enableReinitialize
          onSubmit={submitHandler}
          validationSchema={ExperienceSchema.validationSchema}
        >
          {({ handleSubmit }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Column rowGap={20}>
                  <Fields.Input
                    name="name"
                    placeholder="Enter Organization Name"
                    label="Organizations Name"
                  />
                  <Fields.Input
                    name="role"
                    placeholder="Enter Role"
                    label="Role"
                  />
                  <Fields.Input
                    type="date"
                    name="startDate"
                    placeholder="Start Date"
                    label="Start Date"
                  />
                  <Fields.Input
                    type="date"
                    name="endDate"
                    placeholder="End Date"
                    label="End Date"
                  />
                  <Fields.Checkbox
                    name="isCurrent"
                    label="Currently Working Here"
                  />
                  <Button
                    type="submit"
                    title="Submit"
                    styleButton="width:100%;"
                    height={40}
                    loading={loading}
                  />
                </Column>
              </Form>
            )
          }}
        </Formik>
      </Modal>
    </Column>
  )
}

export default Experiences
